import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private requestCountSubject = new BehaviorSubject<number>(0);
  loaderState: Observable<boolean> = this.requestCountSubject.pipe(map((count) => count > 0));

  show() {
    const newCount = this.requestCountSubject.value + 1;
    this.requestCountSubject.next(newCount);
  }

  hide() {
    const newCount = Math.max(0, this.requestCountSubject.value - 1);
    this.requestCountSubject.next(newCount);
  }
}
